const environmentConfiguration = {
    // 开发环境
    development: {
        // baseUrl: 'http://192.168.0.111:9029/',  //小麦本地
        baseUrl: 'https://test2.lovense-api.com',
        // baseUrl: "http://192.168.0.18:9029",
        fileStatice: 'https://test2.lovense-api.com',
        expiredHost: "https://test1.lovense.com",
        getLangUrl:"https://test7.lovense.com",
        reportUrl:"https://test10.lovense-api.com",
        audioFileUrl: "https://test1.lovense.com",
        logUrl: "https://test4.lovense.com",
        vmUrl: "https://test-front.lovense.com/surfease-js/"
    },
    // 测试环境
    test: {
        baseUrl: 'https://test2.lovense-api.com',
        // baseUrl: "http://192.168.0.18:9029",
        fileStatice: 'https://test2.lovense-api.com',
        expiredHost: "https://test1.lovense.com",
        getLangUrl:"https://test7.lovense.com",
        reportUrl:"https://test10.lovense-api.com",
        audioFileUrl: "https://test1.lovense.com",
        logUrl: "https://test4.lovense.com",
        vmUrl: "https://test-front.lovense.com/surfease-js/"
    },
    // 生产环境
    production: {
        baseUrl: 'https://c.lovense-api.com',
        fileStatice: 'https://cdn.lovense.com',
        expiredHost: "https://lovense.com",
        getLangUrl:"https://date.lovense-api.com",
        reportUrl:"https://apps2.lovense-api.com",
        audioFileUrl: "https://cdn.lovense-api.com",
        logUrl: "https://log.lovense-api.com",
        vmUrl: "https://www.vibemate.com/UploadFiles/surfease/"
    }
}
export default environmentConfiguration[process.env.REACT_APP_ENV]
